<template>
    <div class="home-menu-mob left-menu-mob">
        <div
                class="overlay"
                ref="overlay"
        >
            <nav class="overlayMenu">
                <div class="logo" v-on:click="navToggle">
                    <router-link :to="{name: 'home'}">
                        <img src="/newfrontend/images/logo.svg" alt="">
                    </router-link>
                </div>
                <div class="menu-right">
                    <div class="body " ref="navToggle" v-on:click="navToggle">
                        <div class="menu">
                            <router-link :to="{name: 'home'}" exact>{{__('Home')}}</router-link >
                            <router-link :to="{name: 'marketing'}">{{__('Marketing')}}</router-link>
                            <router-link :to="{name: 'MeetTeam'}">{{__('Our team')}}</router-link>
                            <router-link :to="{name: 'Licenses'}">{{__('Our licenses')}}</router-link>
                            <router-link :to="{name: 'contacts'}">{{__('Contact')}}</router-link>
                            <router-link :to="{name: 'media'}">{{__('Media-center')}}</router-link>
                            <router-link :to="{name: 'mediaCrypto'}">{{__('Crypto news')}}</router-link>
                            <router-link :to="{name: 'instructions'}">{{__('Instructions')}}</router-link>
                            <router-link :to="{name: 'roadmap'}">{{__('RoadMap')}}</router-link>
                            <router-link :to="{name: 'top_page'}">{{__('Top 30')}}</router-link>
                            <router-link :to="{name: 'deals'}">{{__('Trading')}}</router-link>
<!--                            <a :href="__('telegraf_route')" target="_blank">{{__('telegraf_title')}}</a>-->
                        </div>
                        <div class="social">
                            <a href="https://www.facebook.com/Mediacoin.fb" target="_blank">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6667 10.1667H13.8333C14 10.1667 14.0833 10.3333 14.0833 10.5L13.75 12.0833C13.75 12.1667 13.5833 12.25 13.5 12.25H11.6667V18.3333H9.16667V12.3333H7.75C7.58333 12.3333 7.5 12.25 7.5 12.0833V10.5C7.5 10.3333 7.58333 10.25 7.75 10.25H9.16667V7.5C9.16667 6.08333 10.25 5 11.6667 5H13.9167C14.0833 5 14.1667 5.08333 14.1667 5.25V7.25C14.1667 7.41667 14.0833 7.5 13.9167 7.5H11.9167C11.75 7.5 11.6667 7.58333 11.6667 7.75V10.1667Z" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M7.50008 18.3334C3.33341 18.3334 1.66675 16.6667 1.66675 12.5001V7.50008C1.66675 3.33341 3.33341 1.66675 7.50008 1.66675H12.5001C16.6667 1.66675 18.3334 3.33341 18.3334 7.50008V12.5001C18.3334 16.6667 16.6667 18.3334 12.5001 18.3334H7.50008Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </a>
                            <a href="https://instagram.com/mediachain.inc" target="_blank">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13 10C13 9.17188 12.707 8.46484 12.1211 7.87891C11.5352 7.29297 10.8281 7 10 7C9.17188 7 8.46484 7.29297 7.87891 7.87891C7.29297 8.46484 7 9.17188 7 10C7 10.8281 7.29297 11.5352 7.87891 12.1211C8.46484 12.707 9.17188 13 10 13C10.8281 13 11.5352 12.707 12.1211 12.1211C12.707 11.5352 13 10.8281 13 10ZM14.6172 10C14.6172 11.2812 14.168 12.3711 13.2695 13.2695C12.3711 14.168 11.2812 14.6172 10 14.6172C8.71875 14.6172 7.62891 14.168 6.73047 13.2695C5.83203 12.3711 5.38281 11.2812 5.38281 10C5.38281 8.71875 5.83203 7.62891 6.73047 6.73047C7.62891 5.83203 8.71875 5.38281 10 5.38281C11.2812 5.38281 12.3711 5.83203 13.2695 6.73047C14.168 7.62891 14.6172 8.71875 14.6172 10ZM15.8828 5.19531C15.8828 5.49219 15.7773 5.74609 15.5664 5.95703C15.3555 6.16797 15.1016 6.27344 14.8047 6.27344C14.5078 6.27344 14.2539 6.16797 14.043 5.95703C13.832 5.74609 13.7266 5.49219 13.7266 5.19531C13.7266 4.89844 13.832 4.64453 14.043 4.43359C14.2539 4.22266 14.5078 4.11719 14.8047 4.11719C15.1016 4.11719 15.3555 4.22266 15.5664 4.43359C15.7773 4.64453 15.8828 4.89844 15.8828 5.19531ZM10 2.61719C9.94531 2.61719 9.64648 2.61523 9.10352 2.61133C8.56055 2.60742 8.14844 2.60742 7.86719 2.61133C7.58594 2.61523 7.20898 2.62695 6.73633 2.64648C6.26367 2.66602 5.86133 2.70508 5.5293 2.76367C5.19727 2.82227 4.91797 2.89453 4.69141 2.98047C4.30078 3.13672 3.95703 3.36328 3.66016 3.66016C3.36328 3.95703 3.13672 4.30078 2.98047 4.69141C2.89453 4.91797 2.82227 5.19727 2.76367 5.5293C2.70508 5.86133 2.66602 6.26367 2.64648 6.73633C2.62695 7.20898 2.61523 7.58594 2.61133 7.86719C2.60742 8.14844 2.60742 8.56055 2.61133 9.10352C2.61523 9.64648 2.61719 9.94531 2.61719 10C2.61719 10.0547 2.61523 10.3535 2.61133 10.8965C2.60742 11.4395 2.60742 11.8516 2.61133 12.1328C2.61523 12.4141 2.62695 12.791 2.64648 13.2637C2.66602 13.7363 2.70508 14.1387 2.76367 14.4707C2.82227 14.8027 2.89453 15.082 2.98047 15.3086C3.13672 15.6992 3.36328 16.043 3.66016 16.3398C3.95703 16.6367 4.30078 16.8633 4.69141 17.0195C4.91797 17.1055 5.19727 17.1777 5.5293 17.2363C5.86133 17.2949 6.26367 17.334 6.73633 17.3535C7.20898 17.373 7.58594 17.3848 7.86719 17.3887C8.14844 17.3926 8.56055 17.3926 9.10352 17.3887C9.64648 17.3848 9.94531 17.3828 10 17.3828C10.0547 17.3828 10.3535 17.3848 10.8965 17.3887C11.4395 17.3926 11.8516 17.3926 12.1328 17.3887C12.4141 17.3848 12.791 17.373 13.2637 17.3535C13.7363 17.334 14.1387 17.2949 14.4707 17.2363C14.8027 17.1777 15.082 17.1055 15.3086 17.0195C15.6992 16.8633 16.043 16.6367 16.3398 16.3398C16.6367 16.043 16.8633 15.6992 17.0195 15.3086C17.1055 15.082 17.1777 14.8027 17.2363 14.4707C17.2949 14.1387 17.334 13.7363 17.3535 13.2637C17.373 12.791 17.3848 12.4141 17.3887 12.1328C17.3926 11.8516 17.3926 11.4395 17.3887 10.8965C17.3848 10.3535 17.3828 10.0547 17.3828 10C17.3828 9.94531 17.3848 9.64648 17.3887 9.10352C17.3926 8.56055 17.3926 8.14844 17.3887 7.86719C17.3848 7.58594 17.373 7.20898 17.3535 6.73633C17.334 6.26367 17.2949 5.86133 17.2363 5.5293C17.1777 5.19727 17.1055 4.91797 17.0195 4.69141C16.8633 4.30078 16.6367 3.95703 16.3398 3.66016C16.043 3.36328 15.6992 3.13672 15.3086 2.98047C15.082 2.89453 14.8027 2.82227 14.4707 2.76367C14.1387 2.70508 13.7363 2.66602 13.2637 2.64648C12.791 2.62695 12.4141 2.61523 12.1328 2.61133C11.8516 2.60742 11.4395 2.60742 10.8965 2.61133C10.3535 2.61523 10.0547 2.61719 10 2.61719ZM19 10C19 11.7891 18.9805 13.0273 18.9414 13.7148C18.8633 15.3398 18.3789 16.5977 17.4883 17.4883C16.5977 18.3789 15.3398 18.8633 13.7148 18.9414C13.0273 18.9805 11.7891 19 10 19C8.21094 19 6.97266 18.9805 6.28516 18.9414C4.66016 18.8633 3.40234 18.3789 2.51172 17.4883C1.62109 16.5977 1.13672 15.3398 1.05859 13.7148C1.01953 13.0273 1 11.7891 1 10C1 8.21094 1.01953 6.97266 1.05859 6.28516C1.13672 4.66016 1.62109 3.40234 2.51172 2.51172C3.40234 1.62109 4.66016 1.13672 6.28516 1.05859C6.97266 1.01953 8.21094 1 10 1C11.7891 1 13.0273 1.01953 13.7148 1.05859C15.3398 1.13672 16.5977 1.62109 17.4883 2.51172C18.3789 3.40234 18.8633 4.66016 18.9414 6.28516C18.9805 6.97266 19 8.21094 19 10Z" />
                                </svg>
                            </a>
                            <a href="https://twitter.com/mediachaininc?s=21&t=bqNsuZ3WRA3eYfvcGeiMcQ" target="_blank">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.92355 11.831C0.409444 11.8353 -0.567953 13.5601 0.364837 14.867C1.70068 16.7383 4.12308 18.2402 8.16721 18.2402C14.4344 18.2402 19.4651 13.1328 18.7609 7.0986L19.7927 5.03506C20.5082 3.604 19.2648 1.97604 17.6959 2.28983L16.3328 2.56244C15.9714 2.37177 15.5974 2.22787 15.2778 2.12363C14.6548 1.92047 13.9008 1.75977 13.2029 1.75977C11.9492 1.75977 10.8672 2.08142 10.0073 2.72655C9.15714 3.36444 8.67828 4.20276 8.41552 4.97258C8.29439 5.32741 8.21372 5.68334 8.16196 6.02493C7.67555 5.87184 7.17956 5.66587 6.694 5.41434C5.59237 4.84373 4.70156 4.12033 4.19905 3.4861C3.35595 2.422 1.56925 2.5009 0.942284 3.8841C0.0586213 5.83361 0.30102 8.14452 1.09532 10.0118C1.36156 10.6376 1.70788 11.2562 2.13097 11.8296C2.05854 11.8304 1.98925 11.8308 1.92355 11.831ZM8.16669 16.4082C4.6295 16.4082 2.80048 15.127 1.85473 13.8022C1.81224 13.7426 1.85509 13.6614 1.92821 13.6613C2.89034 13.6586 4.86525 13.613 6.16775 12.8507C6.23511 12.8112 6.22029 12.7119 6.1463 12.6871C3.11009 11.6662 1.3842 7.34267 2.60959 4.63924C2.63769 4.57727 2.721 4.56908 2.76328 4.62243C4.16308 6.38918 7.22367 8.11963 9.88652 8.16698C9.94429 8.16798 9.98797 8.11551 9.97918 8.05841C9.87187 7.36275 9.46215 3.59009 13.2024 3.59009C14.0955 3.59009 15.4244 4.02574 15.9138 4.47207C15.9365 4.49269 15.9671 4.50206 15.9972 4.49605L18.0545 4.08459C18.1293 4.06965 18.1885 4.14717 18.1544 4.21531L16.8784 6.76732C16.8695 6.78504 16.8667 6.80536 16.8701 6.82488C17.7638 11.8486 13.6492 16.4082 8.16669 16.4082Z"/>
                                </svg>
                            </a>
                            <a href="https://t.me/mediachaininc" target="_blank">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.83813 8.23015L17.8012 2.07533C18.5421 1.80767 19.1892 2.25607 18.9491 3.37638L18.9505 3.375L16.2325 16.18C16.0311 17.0878 15.4916 17.3085 14.7369 16.8808L10.5978 13.8303L8.60139 15.7536C8.38064 15.9744 8.19438 16.1606 7.76668 16.1606L8.06055 11.9484L15.7317 5.01822C16.0655 4.72434 15.6572 4.55878 15.217 4.85128L5.73715 10.8198L1.65049 9.545C0.763345 9.26354 0.74403 8.65786 1.83813 8.23015Z" />
                                </svg>
                            </a>
                            <a href="https://www.youtube.com/channel/UC1Hf7LezuzqftCwJ8zGNDaQ" target="_blank">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.25 9.22322L8.96429 6.36607C8.85582 6.29715 8.7313 6.25762 8.60294 6.25136C8.47458 6.24509 8.3468 6.27232 8.23214 6.33036C8.11795 6.39199 8.0227 6.48357 7.95663 6.59526C7.89056 6.70695 7.85617 6.83453 7.85714 6.96429V12.6786C7.85617 12.8083 7.89056 12.9359 7.95663 13.0476C8.0227 13.1593 8.11795 13.2509 8.23214 13.3125C8.33747 13.3653 8.45363 13.3928 8.57143 13.3929C8.71062 13.3914 8.84664 13.3512 8.96429 13.2768L13.25 10.4196C13.3495 10.3547 13.4312 10.266 13.4878 10.1616C13.5443 10.0571 13.574 9.94022 13.574 9.82143C13.574 9.70264 13.5443 9.58573 13.4878 9.48128C13.4312 9.37682 13.3495 9.28813 13.25 9.22322ZM9.28571 11.3482V8.29464L11.5714 9.82143L9.28571 11.3482ZM19.4911 4.625C19.409 4.29583 19.2483 3.99146 19.0229 3.73799C18.7974 3.48451 18.5138 3.28949 18.1964 3.16964C15.1429 1.99107 10.2679 2 10 2C9.73214 2 4.85714 1.99107 1.80357 3.16964C1.4862 3.28949 1.20262 3.48451 0.977134 3.73799C0.751652 3.99146 0.590994 4.29583 0.508929 4.625C0.276786 5.50893 0 7.13393 0 9.82143C0 12.5089 0.276786 14.1339 0.508929 15.0179C0.590994 15.347 0.751652 15.6514 0.977134 15.9049C1.20262 16.1583 1.4862 16.3534 1.80357 16.4732C4.73214 17.6071 9.32143 17.6429 9.9375 17.6429H10.0625C10.6786 17.6429 15.2679 17.6071 18.1964 16.4732C18.5138 16.3534 18.7974 16.1583 19.0229 15.9049C19.2483 15.6514 19.409 15.347 19.4911 15.0179C19.7232 14.1339 20 12.5089 20 9.82143C20 7.13393 19.7232 5.50893 19.4911 4.625ZM18.1071 14.6607C18.0808 14.7687 18.0289 14.8689 17.9559 14.9528C17.8829 15.0367 17.7909 15.1018 17.6875 15.1429C14.8571 16.2321 10.0536 16.2143 10 16.2143H9.99107C9.94643 16.2143 5.14286 16.2321 2.3125 15.1429C2.20914 15.1018 2.11711 15.0367 2.0441 14.9528C1.97109 14.8689 1.91923 14.7687 1.89286 14.6607C1.67857 13.8482 1.42857 12.3571 1.42857 9.82143C1.42857 7.28572 1.67857 5.79465 1.89286 4.98215C1.91923 4.87411 1.97109 4.77397 2.0441 4.69009C2.11711 4.6062 2.20914 4.54103 2.3125 4.5C5.03571 3.45536 9.60714 3.42857 9.98214 3.42857H10C10.0536 3.42857 14.8571 3.41072 17.6875 4.5C17.7909 4.54103 17.8829 4.6062 17.9559 4.69009C18.0289 4.77397 18.0808 4.87411 18.1071 4.98215C18.3214 5.79465 18.5714 7.28572 18.5714 9.82143C18.5714 12.3571 18.3214 13.8482 18.1071 14.6607Z" />
                                </svg>
                            </a>
                            <a href="https://www.linkedin.com/company/mediachain-inc/?viewAsMember=true" target="_blank">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2343_3026)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1.75C4.87283 1.75 3.79183 2.19777 2.9948 2.9948C2.19777 3.79183 1.75 4.87283 1.75 6V14C1.75 15.1272 2.19777 16.2082 2.9948 17.0052C3.79183 17.8022 4.87283 18.25 6 18.25H14C15.1272 18.25 16.2082 17.8022 17.0052 17.0052C17.8022 16.2082 18.25 15.1272 18.25 14V6C18.25 4.87283 17.8022 3.79183 17.0052 2.9948C16.2082 2.19777 15.1272 1.75 14 1.75H6ZM1.93414 1.93414C3.01247 0.855802 4.47501 0.25 6 0.25H14C15.525 0.25 16.9875 0.855802 18.0659 1.93414C19.1442 3.01247 19.75 4.47501 19.75 6V14C19.75 15.525 19.1442 16.9875 18.0659 18.0659C16.9875 19.1442 15.525 19.75 14 19.75H6C4.47501 19.75 3.01247 19.1442 1.93414 18.0659C0.855802 16.9875 0.25 15.525 0.25 14V6C0.25 4.47501 0.855802 3.01247 1.93414 1.93414ZM5 7.25C5.41421 7.25 5.75 7.58579 5.75 8V15C5.75 15.4142 5.41421 15.75 5 15.75C4.58579 15.75 4.25 15.4142 4.25 15V8C4.25 7.58579 4.58579 7.25 5 7.25Z" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.51451 4.44408C5.821 4.72271 5.84359 5.19704 5.56496 5.50354L5.55496 5.51454C5.27633 5.82103 4.80199 5.84361 4.4955 5.56498C4.18901 5.28635 4.16642 4.81201 4.44505 4.50552L4.45505 4.49452C4.73368 4.18803 5.20802 4.16544 5.51451 4.44408ZM9 7.25003C9.41422 7.25003 9.75 7.58582 9.75 8.00003V8.84559C10.4177 8.39819 11.2204 8.18753 12 8.18753C12.8972 8.18753 13.8252 8.46659 14.5426 9.06449C15.2773 9.67672 15.75 10.5915 15.75 11.75V15C15.75 15.4142 15.4142 15.75 15 15.75C14.5858 15.75 14.25 15.4142 14.25 15V11.75C14.25 11.0336 13.9727 10.5421 13.5824 10.2168C13.1748 9.87722 12.6028 9.68753 12 9.68753C11.3972 9.68753 10.8252 9.87722 10.4176 10.2168C10.0273 10.5421 9.75 11.0336 9.75 11.75V15C9.75 15.4142 9.41422 15.75 9 15.75C8.58579 15.75 8.25 15.4142 8.25 15V8.00003C8.25 7.58582 8.58579 7.25003 9 7.25003Z" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2343_3026">
                                            <rect width="20" height="20" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="mob-leng">
                    <DropdownLanguages></DropdownLanguages>
                </div>

            </nav>
        </div>
        <div class="navBurger" role="navigation" ref="navToggle" v-on:click="navToggle"></div>
    </div>
</template>

<script>
    import DropdownLanguages from "./DropdownLanguages";
    export default {
        name: 'NavMobileHome',
        data: function() {
            return {
            }
        },
        props: {

        },
        methods: {
            navToggle: function () {
                this.$refs.navToggle.classList.toggle('active');
                this.$refs.overlay.classList.toggle('open');
            }
        },
        components: {
            DropdownLanguages
        }
    }
</script>
<style scoped>
    .social svg {
        fill: #FF0000;
        transition: 200ms;
    }
    .social svg{
        margin: 0px 12px;
    }
    .social{
        list-style: none;
        padding-left: 0;
        margin-top: 55px;
        text-align: center;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        /*padding-bottom: 86px;*/
    }
    .social li{
        display: inline-block;
        margin-right: 15px;
        margin-left: 15px;
    }
    .overlayMenu .body .social a{
         margin-top: 0;

    }
    .social li a:first-child svg{

    }
    .social li a svg{
        fill: #FF0000;
        width: 16px;
        height: 16px;
    }
    .social li a:hover{
        background: #ffffff;
        text-decoration: none;

    }

    .overlayMenu .body{
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        align-content: center;
        margin-top: 30px;
    }
    .overlayMenu .body a{
        margin-top: 20px;
        color: #ffffff;
    }
    .overlayMenu .body a.router-link-exact-active{
        color: #FEDC43;
    }
    .overlayMenu .body a:first-child svg{
        fill: transparent;
        stroke: rgba(30, 40, 51, 0.7)
    }
    .overlayMenu .body a svg{
        fill: rgba(30, 40, 51, 0.7)
    }
    .overlayMenu .logo{
        text-align: center;
        margin-top: 20px;
    }
    .overlayMenu .logo a{

        padding: 0;
        position: relative;
    }
    .overlayMenu .logo a img{
        width: 140px;
    }

    .home-menu-mob{
        display: none;
    }
    .navBurger {
        display: none;
        position: fixed;
        left: 24px;
        top: 24px;
        cursor: pointer;
        background: #BBB5B9;
        box-sizing: border-box;
        background-clip: content-box;
        width: 20px;
        padding-left: 0px;
        padding-right: 0px;
        height: 15px;
        border-top: 6px solid transparent;
        border-bottom: 7px solid transparent;
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: all 0.25s ease-in-out;
        transition: all 0.25s ease-in-out;
        z-index: 111;
    }
    .navBurger:before, .navBurger:after {
        content: "";
        position: absolute;
        background: #BBB5B9;
        height: 2px;
        width: 20px;
        left: 0px;
        will-change: rotate;
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: all 0.5s ease;
        transition: all 0.5s ease;
    }
    .navBurger:before {
        top: -6px;
    }
    .navBurger:after {
        bottom: -6px;
    }
    .navBurger.active {
        margin-top: 0px;
        left: 22px;
        position: fixed;
        z-index: 1111;
        background: transparent;
        background-clip: content-box;
    }
    .navBurger.active:before {
        -webkit-transform: rotate(135deg);
        transform: rotate(135deg);
        top: 0px;
        background: #282828;
        width: 100%;
    }
    .navBurger.active:after {
        bottom: 0px;
        -webkit-transform: rotate(-135deg);
        transform: rotate(-135deg);
        background: #282828;
        width: 100%;
    }
    .overlay {
        position: fixed;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transform-origin: left top;
        transform: scale(0);
        visibility: hidden;
        transition: all 0.4s ease-in-out;
        z-index: 1111;
        background: #FAF8F8;
    }
    .overlay.open {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
        z-index: 1111;
        position: fixed;
    }
    .overlay .menu{
        margin-top: 10px;
        text-align: center;
    }
    .overlay .menu a{
        display: block;
        color: #282828;
        font-size: 14px;
        -webkit-transition: 300ms;
        transition: 300ms;
    }
    .overlay .menu-right a.router-link-exact-active{
        color: #FF0000;
    }
    .overlay .menu-right a:hover{
        color: #FF0000;
    }
    .overlay .menu-right .v-btn--active:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        bottom: -6px;
        background-color: #3C55CF;
        display: block;
    }

    .overlay .menu .v-btn--active{
        color: #3C55CF;
    }


    @media only screen and (max-width : 880px){
        .mob-leng{
            display: none;
        }
        .navbar.is-visible .navBurger.active {
            margin-top: 0px;
            left: 25px;
            position: fixed;
            z-index: 1111;
            background: transparent;
            background-clip: content-box;
        }
        .home-menu-mob{
            display: block;
        }
        .navBurger{
            display: block;
        }
        .navbar.is-visible .navBurger{
            position: fixed;
            left: 25px;
            top: 30px;
            cursor: pointer;
            background: #2a2d38;
            box-sizing: border-box;
            background-clip: content-box;
            width: 20px;
            padding-left: 0px;
            padding-right: 0px;
            height: 15px;
            border-top: 6px solid transparent;
            border-bottom: 7px solid transparent;
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: all 0.25s ease-in-out;
            transition: all 0.25s ease-in-out;
            z-index: 1111;
        }
        .navbar.is-visible  .navBurger:before, .navbar.is-visible  .navBurger:after {
            background: #2a2d38;
        }
    }

</style>
